import React, { Component } from "react";
import ResetPasswordPage from "../ResetPasswordPage";
import EmailVerifiedPage from "../EmailVerifiedPage";
import App404 from "../App404";
import { connect } from "react-redux";

class AuthActionPage extends Component {
  render() {
    const { mode } = this.props;

    if (mode === "resetPassword") {
      return <ResetPasswordPage />;
    } else if (mode === "verifyEmail") {
      return <EmailVerifiedPage />;
    }
    return <App404 />;
  }
}

const mapStateToProps = state => ({
  mode: state.router.query && state.router.query.mode,
});
export default connect(mapStateToProps)(AuthActionPage);



// WEBPACK FOOTER //
// ./src/scenes/AuthActionPage/index.js